//@flow
import * as React from 'react'
import YesNoCheckboxItem from './YesNoCheckboxItem'
import type { YesNoAnswerQuestion$Props } from './flowTypes'

const YesNoAnswerQuestion=(props:YesNoAnswerQuestion$Props)=>{
    return (
        <div className='row'>
            <div className='col-sm'>
                <label>
                    {props.questionText} 
                    <YesNoCheckboxItem 
                      elementId={props.elementId} 
                      yesSubQuestionText={props.yesSubQuestionText}
                      yesSubAnswers={props.yesSubAnswers} 
                      changeFieldValue={props.changeFieldValue} />     
                </label>
            </div>
        </div>
    )
}

export default YesNoAnswerQuestion


// WEBPACK FOOTER //
// ./src/components/QualityReview/YesNoAnswerQuestion.js